import type * as api from '@gitbook/api-client';

import { ContentSourceTranslationPagesBlankslate } from './translation';

/**
 * Blankslate to display in the pages table of contents when there are no pages generated by a
 * given source.
 */
export function ContentSourcePagesBlankslate(props: {
    space: api.Space;
    source: api.ComputedContentSourceRevision;
}) {
    const { space, source } = props;

    switch (source.type) {
        case 'builtin:translation':
            return <ContentSourceTranslationPagesBlankslate space={space} source={source} />;
        default:
            return <>No pages have been generated by this source</>;
    }
}
